import { Box, useTheme } from '@mui/material';
import React, { FC } from 'react';
import { NodeProps } from '@xyflow/react';

type NodeSelectionProps = NodeProps & {
  children: React.ReactNode;
  zoom: number;
};

const NodeSelection: FC<NodeSelectionProps> = (props) => {
  const width = (7 - 5 * (props.zoom - 2)) / 2;

  const theme = useTheme();
  return (
    <Box
      sx={{
        ...(props.selected && {
          borderRadius: 1,
          outlineStyle: 'dashed',
          outlineWidth: width,
          opacity: theme.palette.mode === 'light' ? '65%' : '50%',
          outlineColor: theme.palette.mode === 'light' ? theme.palette.secondary.dark : theme.palette.secondary.light,
          outlineOffset: theme.spacing(0.25)
        })
      }}
    >
      {props.children}
    </Box>
  );
};

export default NodeSelection;
